<template>
<div id="footer">
  <div class="legal">
    <router-link :to="$lp('/tokushoho')">{{ $t('legal.tokushoho') }}</router-link>
    <router-link :to="$lp('/privacy-policy')">{{ $t('legal.privacy') }}</router-link>
  </div>
  <div class="copy">Copyright©{{ thisYear }} Hope Medical. All rights reserved.</div>
</div>
</template>

<script>
export default {
  name: "MFooter",
  data() {
    return {
      thisYear: (new Date()).getFullYear()
    }
  }
}
</script>

<style scoped>
#footer {
  background-color: #1796C4;

  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
}
#footer .legal {
  display: flex;
  justify-content: center;
  gap: 18px;
  padding: 8px 0 0;
  font-size: 11.5px;
}
#footer .legal a {
  color: #FFFFFF;
  text-decoration: underline;
}
#footer .copy {
  height: 32px;
  line-height: 32px;
}
</style>
